<!--
 * @Author: wangjx
 * @LastEditors: yingna.gao
 * @Date: 2021-08-11 13:39:25
 * @LastEditTime: 2022-09-20 14:14:28
 * @Description: 编辑、修改菜单
-->
<template>
  <el-dialog
    v-dialogDrag
    :title="title"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    class="self-dialog-form"
    width="990px"
  >
    <el-form ref="formRef" label-position="top" :rules="formRules" :model="formData">
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="上级菜单" prop="warehouseName">
            <el-input
              v-if="operType !== 'edit'"
              v-model="parentName"
              placeholder="无"
              :disabled="true"
            ></el-input>
            <TreeSelect
              v-if="operType === 'edit'"
              v-model="parentId"
              :multiple="false"
              :disabled="dialogData.menuType === 'BUTTON'"
              :placeholder="$t('common.pleaseChoose')"
              :tree-data="showMenuData"
              :show-node="false"
              :show-search="true"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="菜单类型" prop="menuType" required>
            <el-radio-group v-model="formData.menuType">
              <el-radio label="DIRECTORY" :disabled="dirctoryDisable()">目录</el-radio>
              <el-radio label="MENU" :disabled="operType === 'edit'">菜单</el-radio>
              <el-radio label="BUTTON" :disabled="buttonDisable()">按钮</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="菜单名称" prop="menuName" required>
            <el-input v-model="formData.menuName" placeholder="请输入菜单名称" maxlength="64" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="权限标识" prop="permission">
            <el-input v-model="formData.permission" placeholder="请输入权限标识" maxlength="64" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="菜单编码" prop="menuCode" required>
            <el-input v-model="formData.menuCode" placeholder="请输入菜单编码" maxlength="64" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="路由地址(Href)" prop="menuPath">
            <el-input
              v-model="formData.menuPath"
              placeholder="请输入路由地址(Href)"
              maxlength="255"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="排序(升序)" prop="sort">
            <el-input-number
              v-model="formData.sort"
              :precision="0"
              controls-position="right"
              :min="0"
              :max="2147483647"
              placeholder="请输入排序(升序)"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="资源路径" prop="resourcePath">
            <el-input
              v-model="formData.resourcePath"
              placeholder="请输入页面资源相对路径，如：/dict/dict-list.vue"
              maxlength="255"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col v-if="clientType === 'WEB'" :span="6">
          <el-form-item label="菜单">
            <div style="display: flex">
              <div class="icon_menu" style="width: 40px">
                <div v-if="!!formData.menuIcon" class="menu_icon_delete">
                  <span
                    class="el-icon-close icon_delete"
                    @click.prevent.stop="deleteIcon('menuIcon')"
                  />
                </div>
                <svg-icon :icon-class="formData.menuIcon || 'icon-position'" class="menu_icon" />
              </div>
              <el-popover
                placement="bottom"
                trigger="click"
                width="400"
                :visible-arrow="false"
                class="cursor-p"
                style="flex: 1; padding-top: 1px"
              >
                <div slot="reference" style="width: 100%">
                  <el-button plain style="width: 100%">请选择图标</el-button>
                </div>
                <div class="self-popover-items" style="min-width: 114px">
                  <div class="icon_picker_wrap">
                    <icon-picker @handleIconSelected="handleIconSelected"></icon-picker>
                  </div>
                </div>
              </el-popover>
            </div>
            <!-- <div v-if="iconPickerVisible" class="icon_picker_wrap">
              <icon-picker @handleIconSelected="handleIconSelected"></icon-picker>
            </div> -->
          </el-form-item>
        </el-col>
        <el-col :span="clientType === 'WEB' ? 6 : 12">
          <el-form-item label="工作台">
            <div style="display: flex">
              <div class="icon_menu" style="width: 40px">
                <div v-if="!!formData.menuIconExt" class="menu_icon_delete">
                  <span
                    class="el-icon-close icon_delete"
                    @click.prevent.stop="deleteIcon('menuIconExt')"
                  />
                </div>
                <svg-icon :icon-class="formData.menuIconExt || 'icon-position'" class="menu_icon" />
              </div>
              <el-popover
                placement="bottom"
                trigger="click"
                width="400"
                :visible-arrow="false"
                class="cursor-p"
                style="flex: 1; padding-top: 1px"
              >
                <div slot="reference" style="width: 100%">
                  <el-button plain style="width: 100%">请选择图标</el-button>
                </div>
                <div class="self-popover-items" style="min-width: 114px">
                  <div class="icon_picker_wrap">
                    <icon-picker
                      category="workbench"
                      @handleIconSelected="icon => handleIconSelected(icon, 'menuIconExt')"
                    ></icon-picker>
                  </div>
                </div>
              </el-popover>
            </div>
            <!-- <div v-if="iconPickerVisible" class="icon_picker_wrap">
              <icon-picker @handleIconSelected="handleIconSelected"></icon-picker>
            </div> -->
          </el-form-item>
        </el-col>
        <!-- 是否有效 -->
        <el-col :span="12">
          <el-form-item :label="$t('user.isEffect')" prop="effect">
            <el-radio-group ref="radioGroup" v-model="formData.effect">
              <el-radio :label="true">有效</el-radio>
              <el-radio :label="false">无效</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="描述" prop="description">
            <el-input
              v-model="formData.description"
              type="textarea"
              :placeholder="`${$t('common.pleaseEnter')}内容(${$t('common.wordCountLimit', [
                $getInputMaxLimitConst('limit200')
              ])})`"
              :maxlength="$getInputMaxLimitConst('limit200')"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- 确定取消按钮 -->
    <div slot="footer" class="dialog-footer">
      <el-button plain @click="handleConfirmCancle()">取消</el-button>
      <el-button type="primary" :loading="loading" @click="handleConfirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import SvgIcon from "@/components/common/SvgIcon";
import IconPicker from "@/components/common/IconPicker";
import menuApi from "@/api/menu/menu";
import { Message } from "element-ui";

export default {
  name: "MenuDetail",
  components: {
    SvgIcon,
    IconPicker
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    // 操作的类型，创建new,添加子节点add，修改edit
    operType: {
      type: String,
      default: ""
    },
    // 当前数据类型，取值为WEB和APP,创建时候必传
    clientType: {
      type: String,
      default: "WEB"
    },
    dialogData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      warehouseTypeList: {},
      formData: {},
      loading: false,
      parentId: "",
      parentName: "",
      iconPickerVisible: false, // 图标选择器显示状态
      // 添加表单的验证规则
      formRules: {
        menuName: [
          { required: true, message: "菜单名称不能为空", trigger: "blur" },
          { required: true, message: "菜单名称不能为空", trigger: "change" }
        ],
        menuCode: [
          { required: true, message: "菜单编码不能为空", trigger: "blur" },
          { required: true, message: "菜单编码不能为空", trigger: "change" }
        ],
        menuType: [
          { required: true, message: "类型不能为空", trigger: "blur" },
          { required: true, message: "类型不能为空", trigger: "change" }
        ]
      },
      showMenuData: []
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      }
    },
    dialogLoading: {
      get() {
        return this.loading;
      },
      set(val) {
        this.$emit("update:loading", val);
      }
    }
  },
  watch: {
    dialogData: {
      deep: true,
      handler(val, oldVal) {
        this.parentId = "";
        this.parentName = "";
        this.formData = {
          id: "",
          parentId: "",
          menuName: "",
          menuCode: "",
          menuIcon: "",
          menuIconExt: "",
          menuType: "",
          effect: true,
          menuPath: "",
          sort: "",
          description: ""
        };

        // this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.resetFields();
        // });
        if (val) {
          switch (this.operType) {
            case "edit":
              this.formData = { menuIconExt: "", ...JSON.parse(JSON.stringify(val)) };
              if (!val.parentId) {
                this.$set(this, "parentId", "-1");
              } else {
                this.$set(this, "parentId", val.parentId);
              }
              this.getMenuTree();
              break;
            // 新增时，dialogData为父节点的数据
            case "add":
              this.parentId = this.dialogData.id;
              this.parentName = this.dialogData.menuName;
              if (this.clientType === "APP") {
                this.formData.menuType = "MENU";
              }
              break;
            case "new":
              this.parentName = this.dialogData.menuName;
              break;
            default:
              break;
          }
        }
      }
    }
  },
  methods: {
    /**
     * @description: 获取全量菜单
     * @param {*}
     * @return {*}
     */
    getMenuTree() {
      this.showMenuData = [
        {
          clientType: this.clientType,
          menuName: "根节点",
          menuType: "DIRECTORY",
          isApplaticon: true,
          id: "-1",
          children: [],
          systemDefault: true
        }
      ];
      menuApi.getList({ parseToTree: true, clientType: this.clientType }).then(res => {
        this.showMenuData[0].children = res.data;
        if (this.dialogData.menuType !== "BUTTON") {
          this.filterBtn(this.showMenuData);
        } else {
          this.setTree(this.showMenuData);
        }
      });
    },
    setTree(menuList = []) {
      for (let i = 0; i < menuList.length; i++) {
        menuList[i].label = menuList[i]["menuName"];
        menuList[i].value = menuList[i]["id"];
        if (!menuList[i].parentId) {
          menuList[i].parentId = "-1";
        }
        if (menuList[i].children && menuList[i].children.length) {
          this.setTree(menuList[i].children);
        }
      }
    },
    // 去除按钮
    filterBtn(menuList = []) {
      for (let i = 0; i < menuList.length; i++) {
        menuList[i].label = menuList[i]["menuName"];
        menuList[i].value = menuList[i]["id"];
        if (!menuList[i].parentId) {
          menuList[i].parentId = "-1";
        }
        if (menuList[i].menuType !== "DIRECTORY") {
          menuList.splice(i, 1);
          i--;
        } else if (menuList[i].children && menuList[i].children.length) {
          this.filterBtn(menuList[i].children);
        }
      }
    },
    /**
     * @description: 添加菜单
     * @param {*} data
     * @return {*}
     */
    addMenu(data) {
      const param = { ...data };
      param.parentId = this.parentId;
      param.clientType = this.clientType;
      menuApi
        .addMenu(param)
        .then(res => {
          this.loading = false;
          // eslint-disable-next-line vue/no-mutating-props
          Message({
            message: "添加成功",
            type: "success",
            duration: 5 * 1000
          });
          this.$emit("success");
        })
        .catch(() => {
          this.loading = false;
        });
    },

    /**
     * @description: 编辑
     * @param {*} data
     * @return {*}
     */
    editMenu(data) {
      const param = { ...data };
      param.parentId = this.parentId === "-1" ? "" : this.parentId;
      menuApi
        .editMenu(param)
        .then(res => {
          this.loading = false;
          // eslint-disable-next-line vue/no-mutating-props
          Message({
            message: "编辑成功",
            type: "success",
            duration: 5 * 1000
          });
          this.$emit("success");
        })
        .catch(() => {
          this.loading = false;
        });
    },

    /**
     * @description: 判断是否可以选择目录，
     * 1、只有目录可以添加目录
     * 2、编辑不能改变菜单类型
     * 3、APP只有在新建的时候可以选择，不其他情况不支持
     * @param {*}
     * @return {*}
     */
    dirctoryDisable() {
      return (
        this.operType === "edit" ||
        (this.clientType === "APP" && this.operType !== "new") ||
        this.dialogData.menuType !== "DIRECTORY"
      );
    },

    /**
     * @description: 判断是否可以选择按钮，
     * 1、目录不可以添加按钮
     * 2、新建不能选择按钮
     * 3、编辑不能改变菜单类型
     * 4、APP不支持按钮
     * @param {*}
     * @return {*}
     */
    buttonDisable() {
      return (
        this.dialogData.menuType === "DIRECTORY" ||
        this.operType === "new" ||
        this.operType === "edit" /* ||
        this.clientType === "APP"*/
      );
    },
    deleteIcon(key = "menuIcon") {
      this.$set(this.formData, key, "");
    },

    /**
     * @description: 图标选择事件
     * @return {string} 图标名
     */
    handleIconSelected(icon, key = "menuIcon") {
      this.iconPickerVisible = false;
      this.formData[key] = icon;
    },

    /**
     * @description: 确定
     * @param {*}
     * @return {*}
     */
    handleConfirm() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          this.loading = true;
          if (this.operType === "edit") {
            this.editMenu(this.formData);
          } else {
            this.addMenu(this.formData);
          }
        }
      });
    },

    /**
     * @description: 取消
     * @param {*}
     * @return {*}
     */
    handleConfirmCancle() {
      this.dialogVisible = false;
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.menu_icon {
  width: 2em;
  height: 2em;
  margin-top: 2px;
}
.menu_icon_delete {
  cursor: pointer;
  width: 40px;
  height: 36px;
  left: -6px;
  top: -2px;
  position: absolute;
  border: 1px solid #d4d9e2;
  opacity: 0;
  .icon_delete {
    position: absolute;
    top: -8px;
    right: -8px;
  }
  .el-icon-close {
    color: #fff;
    &:before {
      display: inline-block;
      border-radius: 50%;
      background-color: #9ea5b2;
    }
  }
}
.icon_menu {
  &:hover {
    .menu_icon_delete {
      opacity: 1;
    }
  }
}
.icon_picker_wrap {
  position: relative;
  height: 200px;
  padding: 16px 0 16px 16px;
  border: 1px solid #cccccc;
}
</style>
